import {Dropdown} from "react-bootstrap";
import {Link} from "react-router-dom";
import image001 from "../../../images/Cover Technicien.png";
import NoProfile from "../../../images/User.svg";
import {twMerge} from "tailwind-merge";
import ClientIcon from "../../../images/icons/client";
import SubCategoryIcon from "../../../images/icons/SubCategory";
import EuroIcon from "../../../images/icons/euro";
import {connect} from "react-redux";
import {
  getUser,
  isAuthenticated,
  isLoading,
} from "../../../store/selectors/AuthSelectors";
import {offerStatus, userRoleList} from "../../../utils/constants";
import ImageComponent from "../shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoImage from "../../../images/NoImage.jpg";
import {getDateLocale} from "../../../utils/date";

import {getOfferStatusColor, offerStatusOptions} from "../../../utils/status";
import CategoryIcon from "../../../images/icons/CategoryIcon";
import ZipCodeIcon from "../../../images/icons/zipCode";
import {useChatRoom, useChatRooms} from "../../../hooks/useChat";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import {useAddOffer} from "../../../hooks/useOffers";
import Loader from "../shared/Loader";
import FavIcon from "../../../images/icons/favoriteIcon";

const OfferInfoCard = ({className, offer, user}) => {
  const {onStartNewChat} = useChatRoom();
  const {
    data: chatrooms,
    isLoading,
    isError,
  } = useChatRooms({offerId: offer.id});
  const {
    status,
    pub_Date,
    createdAt,
    address,
    title,
    description,
    minBudget,
    maxBudget,
    Client: client,
    SubCategories,
    ville,
    postCode,
    id,
    viewCount,
  } = offer;
  const categories = Array.from(
    new Set(offer.SubCategories.map((el) => el?.Category?.title)),
  );
  const {onDeleteOffer, onUpdateOffer, onAddFavorite, onRemoveFavorite} =
    useAddOffer();

  const {bg, color} = getOfferStatusColor({status: status});
  const statusLabel = offerStatusOptions.find(
    (el) => el.value === status,
  ).label;
  if (isLoading) return <Loader />;
  if (isError)
    return <div>Erreur lors de la récupération des conversations</div>;

  return (
    <div className="w-full bg-white rounded-xl flex flex-col gap-2 p-6 justify-start items-start">
      <div className="w-full flex justify-between gap-1 items-center flex-wrap-reverse">
        <div className="bg-[#F1F2F7] rounded-md flex !px-[10px] !py-[8px] gap-2 justify-center items-center text-xs font-semibold text-[#19295C] ">
          <ImageComponent
            src={buildImageUrl(SubCategories[0]?.Category?.Sector?.imagePath)}
            alt="secteur"
            title={offer?.SubCategories[0]?.Category?.Sector?.title}
            className=" w-5 "
            fallback={
              <img
                src={NoImage}
                alt=""
                className=" w-5"
                width="130"
                title={offer?.SubCategories[0]?.Category?.Sector?.title}
              />
            }
          />
          <span>{offer?.SubCategories[0]?.Category?.Sector?.title}</span>
        </div>
        <div className="flex justify-end gap-3 items-center flex-grow">
          <span className="text-[#7E7E7E] font-medium text-xs ">
            {viewCount} vue(s)
          </span>

          {user.selectedRole === userRoleList.CLIENT ? (
            <>
              {!!chatrooms?.length ? (
                <Link to={"/messages#" + chatrooms[0]?.id}>
                  <div className="relative bg-[#EFF2F7] w-8 h-8 rounded-full flex justify-center items-center text-[#1A64B9] text-base ">
                    <i className="fi fi-rr-paper-plane flex items-center"></i>
                    {!!chatrooms?.length && (
                      <div class="absolute bg-[#FF6600] text-white text-[8px] font-semibold flex items-center justify-center rounded-full w-[11px] h-[11px] -top-1 -right-1 ">
                        {chatrooms.length}
                      </div>
                    )}
                  </div>
                </Link>
              ) : (
                <div className="relative bg-[#EFF2F7]  w-8 h-8 rounded-full flex justify-center items-center text-[#1A64B9] text-base ">
                  <i className="fi fi-rr-paper-plane flex items-center"></i>
                </div>
              )}

              <Dropdown>
                <DropdownToggle
                  variant=""
                  className=" i-false !p-0 font-bold text-lg "
                >
                  <i className="fi fi-rr-menu-dots-vertical flex items-center"></i>{" "}
                </DropdownToggle>
                <DropdownMenu
                  align="right"
                  className="mt-2 w-[150px] p-0 !rounded-md "
                >
                  {[
                    offerStatus.PUBLIC,
                    offerStatus.VALIDATION_WAITING,
                    offerStatus.DISALLOW,
                  ].includes(offer?.status) && (
                    <div className="cursor-pointer dropdown-item group    !px-4 border-b font-semibold hover:bg-[#EFF2F7]">
                      <Link
                        to={"/annonce/modifier-annonce/" + offer?.id}
                        className="  text-[#3D4465] hover:text-[#3D4465] text-sm"
                      >
                        Modifier
                      </Link>
                    </div>
                  )}
                  <div
                    onClick={() => onDeleteOffer({id: offer?.id})}
                    className="cursor-pointer dropdown-item group    !px-4 !text-[#3D4465] !text-sm border-b font-semibold hover:text-[#FF6600] hover:bg-[#EFF2F7]"
                  >
                    Supprimer
                  </div>
                  <div
                    className="cursor-pointer dropdown-item group    !px-4 !text-[#3D4465] !text-sm border-b font-semibold hover:text-[#FF6600] hover:bg-[#EFF2F7]"
                    onClick={() =>
                      onUpdateOffer({
                        id: offer?.id,
                        body: {status: offerStatus.DISABLED},
                      })
                    }
                  >
                    Cacher
                  </div>
                </DropdownMenu>
              </Dropdown>
            </>
          ) : (
            <div className="flex justify-center items-center m-2 p-2 w-8 h-8 bg-[#EFF2F7] rounded-full text-[#FF6600]">
              {!!offer?.technicianFavorite?.find(
                (tech) => tech.id == user?.Technician?.id,
              ) ? (
                <FavIcon
                  onClick={() => {
                    onRemoveFavorite({id: offer.id});
                  }}
                  className="w-4 h-4 fill-[#FF6600]"
                />
              ) : (
                <i
                  onClick={() => {
                    onAddFavorite({id: offer.id});
                  }}
                  class="fi fi-rr-star flex items-center"
                ></i>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="w-full cursor-pointer text-[#19295C] hover:text-primary font-semibold break-all text-xl ">
        {title}
      </div>
      <div className="flex justify-start items-center gap-2">
        <div
          style={{
            backgroundColor: bg,
            color: color,
          }}
          className={`flex justify-center gap-1 items-center rounded-3xl px-2 leading-6 text-sm font-semibold `}
        >
          <div
            style={{
              backgroundColor: color,
            }}
            className={`w-2 h-2 rounded-full `}
          ></div>
          <span>{statusLabel}</span>
        </div>
        <div className="text-dark flex gap-2 text-[14px] text-nowrap mr-[10px]">
          <i className="fi fi-rr-calendar flex items-center"></i>
          {new Date(offer?.pub_Date ?? offer.createdAt).toLocaleDateString(
            getDateLocale(),
            {
              weekday: "short", // jour de la semaine
              year: "numeric", // année
              month: "short", // mois en toutes lettres
              day: "numeric", // jour du mois
            },
          )}
        </div>
      </div>
      <div className=" text-primary font-semibold text-[16px] flex items-center mt-2 gap-3">
        <span className="text-xl">
          <i className="fi fi-rr-coins flex items-center"></i>
        </span>
        {offer.minBudget}€ - {offer.maxBudget}€{" "}
      </div>
      <div className="flex justify-start items-start gap-2  text-[#7E7E7E] font-bold text-sm mt-2">
        <CategoryIcon className="w-4 h-4 fill-[#1A64B9] !mt-[2px]" />{" "}
        <div className="flex flex-col justify-start gap-3 items-start">
          <span>{offer?.SubCategories[0]?.Category?.title ?? "--"}</span>

          <div className="flex justify-start flex-wrap items-start gap-2">
            {!!SubCategories.length &&
              SubCategories.map((sub) => (
                <div className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-medium text-[13px] leading-4  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] ">
                  {sub.title}
                </div>
              ))}
          </div>
        </div>
      </div>

      <div className="flex justify-start items-center gap-2 mt-2  text-[#7E7E7E] font-bold text-sm">
        <ZipCodeIcon className="w-4 h-4 fill-[#1A64B9]" />{" "}
        {user.selectedRole === userRoleList.CLIENT
          ? (offer?.address ?? "--")
          : (offer?.postCode ?? "--")}
      </div>
      <div className="flex w-full mt-2 gap-2 justify-start items-start font-medium text-[16px] text-[#1A64B9]   ">
        <i className="fi fi-rr-info mt-1 flex items-center"></i>{" "}
        <div data-i18n-skip className="text-[#7e7e7e] text-[15px]  leading-5 text-wrap w-full overflow-hidden ">
          {offer?.description ?? "--"}
        </div>
      </div>
      {user.selectedRole === userRoleList.CLIENT ? (
        [
          offerStatus.PUBLIC,
          offerStatus.VALIDATION_WAITING,
          offerStatus.DISALLOW,
        ].includes(offer?.status) && (
          <Link
            role="button"
            to={"/annonce/modifier-annonce/" + offer?.id}
            className=" !p-0 w-full h-[47px]  rounded-lg text-sm leading-4 font-bold flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
          >
            Modifier l'annonce{" "}
          </Link>
        )
      ) : (
        <button
          onClick={() => {
            onStartNewChat({clientId: client?.id, offerId: id});
          }}
          className="btn !p-0 w-full h-[47px]  rounded-lg text-[12px] flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white Capitalize-first"
        >
          Contacter{" "}
          <span className="text-[#FF6600] capitalize">
            {client?.User?.firstName}
          </span>
        </button>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
    isLoading: isLoading(state),
    user: getUser(state),
  };
};
export default connect(mapStateToProps)(OfferInfoCard);
